<app-page>
    <app-table-layout [columns]="deviceService.ifMobile(1).orElse(3)" [items]="3">
        <div #layout>
            <app-top-businesses [year]="year"></app-top-businesses>
        </div>
        <div #layout>
            <app-top-businesses [year]="year" [month]="month"></app-top-businesses>
        </div>
        <div #layout>
            <app-top-businesses [year]="year" [month]="month" [day]="day"></app-top-businesses>
        </div>
    </app-table-layout>
</app-page>
